var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fedex-good-list-component"},_vm._l((_vm.data),function(val,key,index){return _c('div',{key:index},[_c('FedexGoodDetail',{attrs:{"isBatch":true,"resetData":val,"countryName":key}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }